import React, { useState } from 'react';
import { useDevelopmentDemo } from '../../contexts/DevelopmentDemoContext';
import { DemoSectionHeader } from '../demoShell/DemoSectionHeader';
import { formatTimestamp } from '../../utils/demoStorage';
import { errorClass, fieldClass, glassPanel, labelClass, primaryButton } from '../../utils/demoUi';
const activityStatus = {
  assigned: 'In Progress',
  completed: 'Completed'
} as const;
export function DevParticipantPlan() {
  const {
    state,
    dispatch
  } = useDevelopmentDemo();
  const participantId = state.ui.actingParticipantId;
  const activities = state.activities.filter(activity => activity.participantId === participantId);
  const [errors, setErrors] = useState<Record<string, string>>({});
  const complete = (activityId: string) => {
    const reflection = (state.ui.reflectionDrafts[activityId] ?? '').trim();
    if (!reflection) {
      setErrors(current => ({
        ...current,
        [activityId]: 'Record a reflection before marking the activity complete.'
      }));
      return;
    }
    setErrors(current => ({
      ...current,
      [activityId]: ''
    }));
    dispatch({
      type: 'completeActivity',
      activityId
    });
  };
  return <div data-id="element-637" data-mp="2cvfcfqayuhnb">
      <DemoSectionHeader title="Development Plan" description="Practice activities linked to the review that led to them. Record a reflection to complete each one." data-id="element-638" data-mp="2cv6xztz734a0" />

      {activities.length === 0 ? <div className={`${glassPanel} p-10 text-center`} data-id="element-639" data-mp="2ris0pms5r1he">
          <p className="font-heading font-bold text-ink-dark" data-id="element-640" data-mp="2rja6ba0pms1z">No activities yet</p>
          <p className="mt-2 text-sm text-ink-muted" data-id="element-641" data-mp="2wgtk68thx2te">An activity is assigned after your response has been reviewed.</p>
        </div> : <ul className="space-y-5" data-id="element-642" data-mp="2hr4fi3m72god">
          {activities.map(activity => <li key={activity.id} data-id="element-643" data-mp="2mq7a0u4jt4i3">
              <article aria-labelledby={`${activity.id}-title`} className={`${glassPanel} p-6 lg:p-8`} data-id="element-644" data-mp="3ahmd4p45fpue">
                <p className="flex flex-wrap gap-x-3 text-xs text-ink-muted" data-id="element-645" data-mp="3f82uulf05xmk">
                  <span className="font-mono font-semibold" data-id="element-646" data-mp="3fa5uzy9vd750">{activity.id}</span>
                  <span data-id="element-647" data-mp="3p3jscca97rpt">From review {activity.reviewId}</span>
                  <span data-id="element-648" data-mp="3k4yp03zpgrx5">Assigned {formatTimestamp(activity.assignedAt)}</span>
                  <span className={`font-semibold ${activity.status === 'completed' ? 'text-navy' : 'text-lavender'}`} data-id="element-649" data-mp="3f5vmorb40zsv">
                    {activityStatus[activity.status]}
                  </span>
                </p>
                <h2 id={`${activity.id}-title`} className="mt-2 font-heading text-xl font-bold text-ink-dark" data-id="element-650" data-mp="365qnh4g2l7ps">
                  {activity.title}
                </h2>
                <p className="mt-2 whitespace-pre-wrap leading-relaxed text-ink-dark" data-id="element-651" data-mp="2wfnomnm9ozjj">{activity.instructions}</p>

                {activity.status === 'completed' ? <div className="mt-5 rounded-lg bg-teal-pale px-4 py-3" data-id="element-652" data-mp="2ridzza6pcrwr">
                    <p className="text-xs font-semibold text-ink-muted" data-id="element-653" data-mp="2ndo59ons5jdf">
                      Reflection · completed {activity.completedAt ? formatTimestamp(activity.completedAt) : ''}
                    </p>
                    <p className="mt-1 whitespace-pre-wrap leading-relaxed text-ink-dark" data-id="element-654" data-mp="xxc3fc8rtw0s">{activity.reflection}</p>
                  </div> : <div className="mt-6 border-t border-line pt-5" data-id="element-655" data-mp="16y0k6epjuahd">
                    <label htmlFor={`reflection-${activity.id}`} className={labelClass} data-id="element-656" data-mp="16wpgeew3t2q9">
                      Reflection · what did you try, and what would you do differently?
                    </label>
                    <textarea id={`reflection-${activity.id}`} rows={5} value={state.ui.reflectionDrafts[activity.id] ?? ''} onChange={event => dispatch({
              type: 'setReflectionDraft',
              activityId: activity.id,
              text: event.target.value
            })} aria-invalid={Boolean(errors[activity.id])} className={fieldClass} data-id="element-657" data-mp="f5jdxrswusxt" />
                    {errors[activity.id] && <p className={errorClass} data-id="element-658" data-mp="gdec2q5v0pe">{errors[activity.id]}</p>}
                    <button type="button" onClick={() => complete(activity.id)} className={`mt-4 ${primaryButton}`} data-id="element-659" data-mp="235wuk290xt50">
                      Complete Activity
                    </button>
                  </div>}
              </article>
            </li>)}
        </ul>}
    </div>;
}